// extracted by mini-css-extract-plugin
export default {"container":"_FAQSectionStyles_container__tCBsI","faq-body":"_FAQSectionStyles_faq-body__dkeEe"};